/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateEstimatedRevenueRequest } from '../../models/create-estimated-revenue-request';

export interface CreateEstimatedRevenue$Params {
      body: CreateEstimatedRevenueRequest
}

export function createEstimatedRevenue(http: HttpClient, rootUrl: string, params: CreateEstimatedRevenue$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, createEstimatedRevenue.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

createEstimatedRevenue.PATH = '/v0/estimatedRevenue';
